import React from 'react'
import { Container,Row,Col } from 'react-bootstrap';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export default function FAQ() {
    return (
        <section id="FAQ">
            <Container className="faq-container" >
                <Row className="justify-content-md-center">
                    <Col className="faq-definition" >
                        <h1>FAQ</h1>
                        <Accordion elevation={0}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                               How can I register for a workshop ? 
            </AccordionSummary>
                            <AccordionDetails>
                            You can do that by filling this form. Once the registration is closed, we will contact you via the email address you provided and give you more details about the workshop. 

            </AccordionDetails>
                        </Accordion>
                        <Accordion elevation={0}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                           How can I register for the talks ? 
            </AccordionSummary>
                            <AccordionDetails>
                            You don’t need any registration to attend the talks. You can fill this form if you want to get notified by email 30min before the beginning of the event. The talks will all be available live on Facebook and Youtube.

            </AccordionDetails>
                        </Accordion>
                        <Accordion elevation={0}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                              Is it Online Event?
            </AccordionSummary>
                            <AccordionDetails>
                            This year’s edition will be entirely online! The event will be live on 
                             Facebook 
                               and Youtube. 
                    You can check for last year’s gallery here. 

            </AccordionDetails>
                        </Accordion>
                        <Accordion elevation={0}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                 Do I need to be a member to attend it?

            </AccordionSummary>
                            <AccordionDetails>
                            No, it’s an open event where everyone is welcome to attend. Feel free to interact with us during the fun activities and ask as many questions you like during the workshops and talks. 


            </AccordionDetails>
                        </Accordion>
                        <Accordion elevation={0}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                              Do I need to have skills in the AI field to join you?

            </AccordionSummary>
                            <AccordionDetails>
                            The event includes a dedicated track for beginners where you’ll learn how to build a simple classifier and the mathematical concepts behind it. You can also check the talks and keynote to get an idea of the trending and recent topics around AI in 2020.


            </AccordionDetails>
                        </Accordion>
                        
                        <Accordion elevation={0}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                What type of workshops do you do?

            </AccordionSummary>
                            <AccordionDetails>
                            The workshops consist of three hours mixing between concepts explanation and coding section. We believe that jupyter notebooks are the best way to include both theoretical and implementation understanding. In this edition, we propose four tracks of workshops, you can attend anyone of them depending on your level and interest: Beginner, Computer vision, NLP and Reinforcement Learning. Please check the schedule page to get more information. 
            </AccordionDetails>
                        </Accordion>
                        <Accordion elevation={0}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                               What are the talks about ? 
            </AccordionSummary>
                            <AccordionDetails>
                            The talks are 20-30min long presentations from experts in the field followed by 10min answering questions of the audience. You can get a full list of the topics and schedule on this page.


            </AccordionDetails>
                        </Accordion>
                        <Accordion elevation={0}>
                            <AccordionSummary

                            >

                            </AccordionSummary>

                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
